import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {IfLoggedIn, IfNotLoggedIn} from "../components/ifLoggedIn";
import {useGallerys} from "../api/galleryapi";
import {Button, Col, Row} from "react-bootstrap";
import {minioBaseUrl} from "../data/defaultConfig";

export function PicturesPage(props) {
    const {galleries} = useGallerys();
    console.log(galleries)
    galleries?.sort((g1,g2)=> new Date(g2.dateCreated) - new Date(g1.dateCreated));
    return <BasePageLayout title={"Gallerijen"}>
        <IfNotLoggedIn>
            <p> Voor foto's te bekijken moet u ingelogd zijn! <span><Button href={'/login'}
                                                                            className={'ms-2'}>Login</Button> </span>
            </p>
        </IfNotLoggedIn>
        <IfLoggedIn>
            <Row className={'g-0 justify-content-between'}>
                {galleries?.map(g => <GalleryItem key={g.id} gallery={g}/>)}
            </Row>
        </IfLoggedIn>
    </BasePageLayout>
}

function GalleryItem(props) {
    const {gallery} = props;
    return <Col xs={4} className={'p-2 text-center'}>
        <Button href={`/fotos/gallerij/${gallery.id}`} className={'btn-light p-0 m-0 bg-transparent text-black'}>
            <Row className={'g-0 rounded-2 shadow-lg '}>
                <Col xs={12}>
                    <img className={'rounded-top-2'} width={'100%'} src={minioBaseUrl + gallery?.filegallery?.url} alt={"gallerij foto"}/>
                </Col>
                <Col className={'mt-2'}>
                    <h6>{gallery.title}</h6>
                </Col>
            </Row>
        </Button>

    </Col>
}